// extracted by mini-css-extract-plugin
module.exports = {"basic":"property-archive-basic-info_basic__ruReN"};